import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../Utils/Utils.js";
import CreatableSelect from "react-select/creatable";
import "../Utils/Utils.css";

function AddFavoritesToGroup(props) {
  const { t } = useTranslation();
  const [selectedOptions, setSelectedOptions] = useState();
  const [options, setOptions] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const url =
    process.env.REACT_APP_SOPHYAPP_API_URL +
    "/de/react/" +
    getAccessToken() +
    "/settings/get_favorite_groups";
  const url_assigned_groups =
    process.env.REACT_APP_SOPHYAPP_API_URL +
    "/de/react/" +
    getAccessToken() +
    "/settings/get_favorite_group_of_exercise";

  useEffect(() => {
    // Only make API calls when modal is actually shown
    if (props.show) {
      axios
        .get(url)
        .then((response) => {
          const options = response.data;
          setOptions(options);
        })
        .catch(() => {});
    }
  }, [url, props.show]);

  useEffect(() => {
    // Only make API calls when modal is actually shown
    if (props.show) {
      var params = new FormData();
      params.append("source_id", props.exercise.id);
      axios
        .get(url_assigned_groups, {
          params: {
            source_id: props.exercise.id,
          },
        })
        .then((response) => {
          const optSelected = response.data.map((item) => ({
            label: item.group_name,
            value: item.id,
          }));
          setSelectedOptions(optSelected);
        })
        .catch(() => {});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  const handleSubmit = (event) => {
    let param_arr = [];
    const url =
      process.env.REACT_APP_SOPHYAPP_API_URL +
      "/de/react/" +
      getAccessToken() +
      "/settings/edit_favorite_group";
    var params = new FormData();
    selectedOptions.map((option) => param_arr.push(option));
    params.append("groups", JSON.stringify(param_arr));
    params.append("source_id", props.exercise.id);

    axios
      .post(url, params)
      .then(function () {
        //Bootstrap Alert
      })
      .catch(function () {
        alert("failed");
      });
    props.onHide();
    event.preventDefault();
  };

  const createOption = (label, id) => ({
    label: label,
    value: id,
  });

  const handleCreateOption = (inputValue) => {
    setIsLoading(true);
    const url =
      process.env.REACT_APP_SOPHYAPP_API_URL +
      "/de/react/" +
      getAccessToken() +
      "/settings/create_new_fav_group";
    var params = new FormData();
    params.append("name", inputValue);
    axios
      .post(url, params)
      .then(function (response) {
        const updatedOptions = [...options, response.data];
        setIsLoading(false);
        setOptions(updatedOptions);
        const selectedUpdatedOptions = [
          ...selectedOptions,
          createOption(response.data.group_name, response.data.id),
        ];
        setSelectedOptions(selectedUpdatedOptions);
      })
      .catch(function () {
        alert("failed");
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("exercises.addToFavorites")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Control value={1} type="hidden" name="id" />
            </Form.Group>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("exercises.favoriteGroups")}</Form.Label>
            <CreatableSelect
              isMulti
              isClearable
              formatCreateLabel={(inputValue) => `Erstelle: "${inputValue}"`}
              isDisabled={isLoading}
              isLoading={isLoading}
              name="groups"
              defaultValue={selectedOptions}
              options={options?.map((option) => ({
                label: option.group_name,
                value: option.id,
              }))}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={setSelectedOptions}
              value={selectedOptions}
              onCreateOption={(inputValue) => handleCreateOption(inputValue)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("profile.save")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default AddFavoritesToGroup;
